import HeroHome from "../components/home/herohome";
import Philosophy from "../components/home/philosophy.js";
import ValueAdded from "../components/home/valueadded.js";
import Impact from "../components/home/impact.js";
import StrategySustainability from "../components/home/strategysustainability.js";
import Background from "../components/home/background.js";
import Footer from "../components/footer/footer.js";

export default function HomeAI() {
  return (
    <>
      <HeroHome />
      <Philosophy />
      <ValueAdded />
      <Impact />
      <StrategySustainability />
      <Background />
      <Footer />
    </>
  );
}